import React from "react";
import Grid from "@material-ui/core/Grid";
import Money from "../../../assets/images/ic_money.png";
import GoldenBackground from '../../../assets/images/img_yellow_wood.png'
import {textAbbreviation} from "../../../Utility/Func";

class SingleBoard extends React.Component{
    constructor() {
        super();
    }
    render() {
        const {
            layerColor,
            avatarHolder,
            score,
            prize,
            price,
            name,
            squareWood,
            rank,
            rankColor,
            woodenBackground,
            boardType,
            starIcon,
            avatar,
            pos
        }=this.props.data
        return(
                <Grid item sm={12} xs={12} container justify={"space-around"}>
                    <Grid item container alignItems='center' justify='flex-start' sm={8}  xs={8}
                          className='single-rank-rectangle'
                    style={{
                        backgroundImage:`url( ${pos<=10?GoldenBackground:woodenBackground})`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '50% 50%',
                    }}
                    >
                        {/*<Grid item className='single-rank-rectangle-layer'*/}
                        {/*      style={{height:'100%',backgroundColor:layerColor}}*/}
                        {/*/>*/}
                        <Grid container justify={"space-between"} sm={12} xs={12}>
                            <Grid container direction={"column"} sm={8} xs={8} style={{backgroundColor:'',flexDirection:'inherit'}}>
                                <Grid item alignItems={"flex-start"}  sm={12} xs={12} direction={"row-reverse"} container justify={"space-between"}
                                      style={{zIndex:'5',transform:'translateY(20%)'}} >
                                    <Grid item container justify={"center"} alignItems={"flex-end"} sm={5} xs={5}>
                                        <p>
                                            {textAbbreviation(name,6)}
                                        </p>
                                    </Grid>
                                    <Grid item container justify={"center"} alignItems={"center"} sm={5} xs={5}>
                                        <Grid sm={4} xs={4} container justify={"center"} alignItems={"center"}>
                                            <img src={Money} style={{width:'100%'}} alt=""/>
                                        </Grid>
                                        <Grid sm={4} xs={4} container justify={"center"} alignItems={"center"}>
                                            <p style={{color:'purple'}}>
                                                {prize}
                                            </p>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item  sm={12} xs={12} direction={"row"} container justify={"space-between"}
                                      style={{zIndex:'5',transform:'translateY(-20%)'}}>
                                    <Grid item container justify={"center"} alignItems={"center"} sm={5} xs={5}>
                                        <p style={{direction:'rtl',color:'#ffffff'}}>
                                            {price}
                                        </p>
                                    </Grid>
                                    <Grid item style={{direction:'rtl'}} container justify={"center"} alignItems={"center"} sm={5} xs={5}>
                                        <p style={{color:'yellow'}}>
                                            امتیاز:
                                        </p>
                                        <p style={{color:'purple'}}>
                                            {score}
                                        </p>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container justify={"center"} alignItems={"center"}  sm={4} xs={4} style={{
                                // backgroundColor:'blue',
                                // backgroundImage:"url(" + avatarHolder + ")",
                                // backgroundSize: '100% 100%',
                                // backgroundRepeat: 'no-repeat',
                                // backgroundPosition: '50% 50%',
                                // padding:'10px',
                                position:'relative',
                                transform:'translateX(30%)'
                            }}
                            >
                                <img src={avatarHolder} style={{position:'absolute',width:'80%'}} alt=""/>
                                <img src={avatar} style={{position:'absolute',width:'55%'}} alt=""/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item justify='center' alignItems='center' container sm={2} xs={2}  className='single-rank-square'>
                        <img src={squareWood} className='single-rank-square-image' alt=""/>
                        <h3 style={{position:'absolute',color:rankColor}}>
                            {rank}
                        </h3>
                    </Grid>
                </Grid>
        )
    }
}
export default SingleBoard